import React from 'react';
import { FEATURED_BADGE } from '../../../common/constants/data-hooks';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import styles from './featured-badge.module.scss';
import { getMarkedCommentIcon } from '../../../common/utils/get-marked-comment-icon';
export const FeaturedBadge = ({ customBadgeLabel, customBadgeIcon }) => {
    const t = useTranslate();
    const Icon = getMarkedCommentIcon(customBadgeIcon);
    return (React.createElement("div", { className: styles.root, "data-hook": FEATURED_BADGE },
        Icon && React.createElement(Icon, null),
        customBadgeLabel || t('featured-badge.featured')));
};
//# sourceMappingURL=featured-badge.js.map